import { LoginForm } from '@/features/consumer/login-form';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_auth-layout/login')({
  component: RouteComponent,
});

function RouteComponent() {
  return <LoginForm />;
}
